// Utilitários
import { getBrazilianStates } from '@/utils';
import { USER_TYPE } from '@/utils/constants';
import { required } from 'vuelidate/lib/validators';
// Módulos
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment-business-days';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
// Requisições
import { getContractor, getDrafts } from '@/services';
import { getQuotationsRequest } from '@/services/api/quotation';
import { getCostCenters, createCostCenter, sendNotification } from '@/services/api/quotation';
import { getQuotationCategories } from '@/utils/quotation-categories-service';

import { saveFiles } from '@/services/s3-upload-service';
export default {
    name: 'NewCompetotionsForm',
    props: {
        setInvitedSuppliers: Object,
        saveDraftButtonDisabled: Boolean,
        loadingDraft: Boolean,
        loadingNewQuotation: Boolean
    },
    data: () => ({
        completedCompetition: false,
        textRules: {
            name: '',
            type: 'text',
            required: true,
            valid: true
        },
        emailRules: {
            name: 'E-mail',
            type: 'email',
            required: false,
            valid: true
        },
        titleRules: {
            name: 'Título da Cotação',
            type: 'text',
            required: true,
            valid: true,
            lengthMax: 40
        },
        flatPickrOptions: {
            monthSelectorType: 'dropdown',
            // altInput: true,
            allowInput: true,
            altFormat: 'd/m/Y',
            dateFormat: 'd/m/Y',
            disable: [
                function(date) {
                    return date.getDay() === 0 || date.getDay() === 6;
                }
            ],
            locale: Portuguese,
            minDate: moment(new Date(), 'DD-MM-YYYY')
                .startOf('day')
                .businessAdd(3)._d,
            mode: 'single'
        },
        form: {
            attachments: [],
            competitionEndingDate: '',
            competitionTitle: '',
            construction: '',
            constructionCep: '',
            constructionCity: '',
            constructionComplement: '',
            constructionDistrict: '',
            constructionState: '',
            constructionStreet: '',
            constructionUnit: '',
            costCenter: '',
            items: [],
            links: [{ link: '' }],
            maximumAmount: 5,
            meetingInfo: '',
            meetingPhone: '',
            meetingResponsible: '',
            observation: '',
            phone: '',
            phoneVisible: true,
            quotationResponsible: '',
            requesterName: '',
            requesterEmail: '',
            requesterPhone: ''
        },
        valid: false,
        hasError: false,
        hasInviteError: false,
        loading: false,
        maximumAmounts: [
            { value: 5, label: 'Até 5' },
            { value: 10, label: 'Até 10' },
            { value: 20, label: 'Até 20' },
            { value: 1000, label: 'Livre' }
        ],
        contractor: {
            name: '',
            trading_name: ''
        },
        amountMask: {
            decimal: ',',
            thousands: '.',
            prefix: '',
            precision: 2,
            masked: false
        },
        invitedSuppliers: [],
        supplierEmail: '',
        supplierTradingName: '',
        draftId: undefined,
        showSpinner: false,
        attachmentSpinnerFlags: [false],
        states: [],
        isFileValid: true,
        isFileLoading: false,
        partner: {
            name: ''
        },
        categories: [],
        select2Options: {
            deselectLabel: 'Remover',
            selectedLabel: 'Selecionado',
            selectLabel: 'Selecionar'
        },
        USER_TYPE: USER_TYPE,
        costCenters: [],
        quotationRequestAttachments: [],
        isReviewingRequest: '{{ strlen($quotationRequest) > 0 }}'
    }),
    async created() {
        this.error = new Array(11);
        this.states = getBrazilianStates();
        this.categories = getQuotationCategories(this.partner.name.toLowerCase());

        try {
            const contractorResponse = await getContractor();
            if (contractorResponse.length) {
                this.contractor = contractorResponse[0];
                this.form.construction = this.contractor.tradingName || '';
                this.form.constructionCep = this.contractor.postalCode || '';
                this.form.constructionCity = this.contractor.city || '';
                this.form.constructionComplement = this.contractor.complement || '';
                this.form.constructionDistrict = this.contractor.neighborhood || '';
                this.form.constructionState = this.contractor.state || '';
                this.form.constructionStreet = this.contractor.street || '';
                this.form.constructionUnit = this.contractor.number || '';
                this.form.phone = this.contractor.phone;
                this.form.quotationResponsible = this.contractor.name;
            }
            this.form.maximumAmount = this.maximumAmounts[0].value;
        } catch (error) {
            console.error(error);
        }

        if (this.userType() == USER_TYPE.CONDO_ADMINISTRATOR) {
            await this.getCostCenters();
        }
        const { isDraftEdit } = this.$route.params;
        if (isDraftEdit) {
            try {
                const { draftId } = this.$route.params;
                const { drafts } = await getDrafts(draftId);

                this.draftId = draftId;

                const data = drafts;
                this.form.budgetRange = data.budget;
                this.form.competitionEndingDate = moment(data.endingDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
                this.form.competitionObjective = data.competitionObjective;
                this.form.competitionTitle = data.title;
                this.form.construction = data.construction;
                this.form.constructionCep = data.constructionCep;
                this.form.constructionCity = data.constructionCity;
                this.form.constructionComplement = data.constructionComplement;
                this.form.constructionDistrict = data.constructionDistrict;
                this.form.constructionState = data.constructionState;
                this.form.constructionStreet = data.constructionAddress;
                this.form.constructionUnit = data.constructionUnit;
                this.form.costCenter = data.costCenter;
                this.form.meetingInfo = data.meetingInfo;
                this.form.meetingPhone = data.technicalVisitResponsiblePhone;
                this.form.meetingResponsible = data.technicalVisitResponsible;
                this.form.quotationResponsible = data.constructionResponsible;
                this.form.requesterEmail = data.requesterEmail;
                this.invitedSuppliers = data.recipients && data.recipients.suppliers ? data.recipients.suppliers : [];

                if (data.items && data.items.items.length > 0) {
                    this.form.items = data.items.items;
                }
                if (data.links && data.links.links.length > 0) {
                    this.form.links = data.links.links.map(entry => {
                        const newEntry = {};
                        newEntry['link'] = entry;
                        return newEntry;
                    });
                }
                this.form.maximumAmount = data.supplierMaximumAmount ? data.supplierMaximumAmount : 5;
                this.form.observation = data.obs;
                this.form.phone = data.phone;
                this.form.phoneVisible = true;
                if (data.questions && data.questions.questions.length > 0) {
                    this.form.questions = data.questions.questions.map(entry => {
                        const newEntry = {};
                        newEntry['question'] = entry;
                        return newEntry;
                    });
                }
            } catch (error) {
                console.error(error);
            }
        } else {
            this.form.quotationResponsible = this.contractor.name;
        }

        if (this.userType() == USER_TYPE.CONDO_ADMINISTRATOR && this.$route.name != 'NewCompetition') {
            const data = await getQuotationsRequest(this.$route.params.id);
            this.form.competitionEndingDate = moment(data.endingDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
            this.form.competitionTitle = data.title;
            this.form.construction = data.tradingName;
            this.form.constructionCep = data.cep;
            this.form.observation = data.observations;
            this.form.constructionCity = data.city;
            this.form.constructionComplement = data.complement;
            this.form.constructionDistrict = data.neighborhood;
            this.form.constructionState = data.state;
            this.form.constructionStreet = data.street;
            this.form.constructionUnit = data.unit;
            this.form.meetingInfo = data.meetingInfo;
            this.form.quotationResponsible = data.responsible;
            this.form.meetingResponsible = data.technicalVisitResponsible;
            this.form.meetingPhone = data.technicalVisitResponsiblePhone;
            this.form.phone = data.requester.phone;
            this.form.requesterEmail = data.requester.contractorEmail;
            this.quotationRequestAttachments = data.attachments;
            this.form.maximumAmount = this.maximumAmounts[0].value;
            this.contractor = data.requester;
            this.valid = !this.valid;
        }
    },
    async destroyed() {
        if (
            (this.form.quotationResponsible.trim().length || this.form.phone.trim().length) &&
            !this.completedCompetition
        ) {
            await sendNotification(this.form);
        }
    },
    computed: {
        inputFieldCondo() {
            return this.userType() == USER_TYPE.CONDO_ADMINISTRATOR
                ? 'input-field col xl4 l4 m4 s12'
                : 'input-field col xl6 l6 m6 s12';
        },
        validateForm() {
            return this.textRules.valid && this.titleRules.valid && this.emailRules.valid ? true : false;
        },
        isEngelinkPartner() {
            return this.partner && this.partner.name.toLowerCase().length > 0;
        },
        showCreateCostCenterButton: function() {
            return !this.form.costCenter || this.form.costCenter.length === 0;
        }
    },
    methods: {
        ...mapGetters('user', ['userType']),
        ...mapActions('notification', ['showNotification']),
        async validateDraft() {
            this.valid = !this.valid;
            await setTimeout(() => {}, 1000);
            this.$v.form.competitionTitle.$touch();
            if (this.validateForm && !this.$v.form.competitionTitle.$invalid) {
                const data = await this.buildCompetitionBody(true);
                this.$emit('save-draft', { data, draftId: this.draftId });
            } else {
                this.$emit('show-error', 'Preencha os campos obrigatórios');
            }
        },
        async validateCreationCompetitionForm() {
            this.valid = !this.valid;
            await setTimeout(() => {}, 1000);
            this.$v.form.competitionTitle.$touch();
            if (this.validateForm && !this.$v.form.competitionTitle.$invalid) {
                try {
                    const data = await this.buildCompetitionBody();
                    this.$emit('save-quotation', data);
                    this.completedCompetition = true;
                } catch (error) {
                    console.error(error);
                }
            } else {
                this.$emit('show-error', 'Preencha os campos obrigatórios');
            }
        },
        async buildCompetitionBody(isDraft) {
            let requestLinks = this.form.links.map(entry => entry.link);
            requestLinks = requestLinks.filter(function(link) {
                return link && link.length > 0;
            });

            let endingDate = moment(new Date(), 'DD-MM-YYYY').format('YYYY-MM-DD');
            if (this.form.competitionEndingDate.length > 0) {
                endingDate = moment(this.form.competitionEndingDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
            }

            let files = [];
            if (!isDraft) {
                if (this.form.attachments.length >= 1 && this.form.attachments[0].file_name.length > 0) {
                    try {
                        const uploadFilesToS3BucketResponse = await saveFiles(this.form.attachments);
                        files = uploadFilesToS3BucketResponse;
                    } catch (error) {
                        console.error(error);
                        this.showSpinner = false;
                        // showAttachmentErrorModal();
                        files = [];
                        return;
                    }
                }
            }

            files = files.concat(this.quotationRequestAttachments);

            const data = {
                admin_recipients: { suppliers: [] },
                construction: this.form.construction,
                construction_address: this.form.constructionStreet || '',
                construction_cep: this.form.constructionCep || '',
                construction_city: this.form.constructionCity || '',
                construction_complement: this.form.constructionComplement || '',
                construction_district: this.form.constructionDistrict || '',
                construction_responsible: this.form.quotationResponsible,
                construction_state: this.form.constructionState || '',
                construction_unit: this.form.constructionUnit || '',
                cost_center: this.form.costCenter,
                ending_date: endingDate,
                files: files,
                items: {
                    items: [
                        {
                            amount: '1',
                            index: 0,
                            measure: 'Verba',
                            name: this.form.competitionTitle
                        }
                    ]
                },
                links: { links: requestLinks },
                obs: this.form.observation,
                phone: this.form.phone,
                phone_visible: true,
                questions: { questions: [] },
                recipients: { suppliers: this.invitedSuppliers },
                supplier_maximum_amount_limit: parseInt(this.form.maximumAmount),
                title: this.form.competitionTitle,
                meeting_info: this.form.meetingInfo,
                technical_visit_responsible: this.form.meetingResponsible,
                technical_visit_responsible_phone: this.form.meetingPhone,
                quotation_request: this.$route.params.id,
                requester_email: this.form.requesterEmail
            };

            return data;
        },
        async createCostCenter() {
            try {
                this.loading = true;
                const data = {
                    cep: this.form.constructionCep,
                    city: this.form.constructionCity,
                    complement: this.form.constructionComplement,
                    district: this.form.constructionDistrict,
                    name: this.form.construction,
                    state: this.form.constructionState,
                    street: this.form.constructionStreet,
                    unit: this.form.constructionUnit
                };
                const { id } = await createCostCenter(data);
                this.form.costCenter = '';
                await this.getCostCenters();
                this.form.costCenter = id;
                this.showNotification({ text: 'Centro de custo criado com sucesso', type: 'success' });
            } catch (error) {
                this.showNotification({ text: 'Verifique os dados do Condomínio', type: 'error' });
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
        removeSupplier(index) {
            this.invitedSuppliers.splice(index, 1);
        },
        async getCostCenters() {
            try {
                const { results } = await getCostCenters();
                results.forEach(r => {
                    r.value = r.id;
                });
                this.costCenters = results;
            } catch (error) {
                console.error(error);
            }
        },
        removeLink(index) {
            if (this.form.links.length > 1) {
                this.form.links.splice(index, 1);
            }
        },
        addLink() {
            const emptyLink = {
                link: ''
            };
            this.form.links.push(emptyLink);
        },
        removeAttachment(index) {
            this.form.attachments.splice(index, 1);
        },
        removeQuotationRequestAttachment(index) {
            this.quotationRequestAttachments.splice(index, 1);
        },
        convertFileToBase64(event) {
            const self = this;
            for (const file of event.target.files) {
                const reader = new FileReader();
                reader.onload = function(e) {
                    // const base64Data = e.target.result;
                    self.isFileValid = self.validateAttachmentSize(file);
                    self.isFileLoading = false;
                    if (self.isFileValid) {
                        self.form.attachments.push({
                            file: e.target.result,
                            file_name: file.name
                        });
                        // $(".attachment, .file-path").val("");
                    }
                };
                reader.onerror = function(error) {
                    console.error(error);
                    self.isFileLoading = false;
                };

                if (file) {
                    self.isFileLoading = true;
                    reader.readAsDataURL(file);
                }
            }
        },
        validateAttachmentSize(file) {
            const maximumFileSizeInMegabytes = 25;
            const fileSizeInMegabytes = file.size / 1024 / 1024;
            return fileSizeInMegabytes <= maximumFileSizeInMegabytes;
        },
        cepRequest(data) {
            this.form.constructionCity = data.city;
            this.form.constructionDistrict = data.neighborhood;
            this.form.constructionState = data.state;
            this.form.constructionStreet = data.street;
        },
        addTag(value) {
            this.categories.push(value);
            this.form.competitionTitle = value;
        }
    },
    validations: {
        form: {
            competitionTitle: {
                required
            }
        }
    },
    watch: {
        setInvitedSuppliers: {
            deep: true,
            handler(val) {
                this.invitedSuppliers.push(val);
            }
        },
        'form.costCenter': function(value) {
            if (value) {
                const costCenter = this.costCenters.find(costCenter => {
                    return costCenter.id === value;
                });

                if (costCenter) {
                    this.form.construction = costCenter.name;
                    this.form.constructionCep = costCenter.cep;
                    this.form.constructionCity = costCenter.city;
                    this.form.constructionComplement = costCenter.complement;
                    this.form.constructionDistrict = costCenter.district;
                    this.form.constructionState = costCenter.state;
                    this.form.constructionStreet = costCenter.street;
                    this.form.constructionUnit = costCenter.unit;
                }
            }
        }
    }
};
